import { Reveal } from "./Reveal";

export default function SectionHead({ overline, title, sub, center = false, testid }) {
  return (
    <div className={`mb-14 max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      <Reveal>
        <p className="mb-4 font-mono text-xs uppercase tracking-[0.28em] text-sky-400">{overline}</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 data-testid={testid} className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.16}>
          <p className="mt-4 text-base leading-relaxed text-slate-400">{sub}</p>
        </Reveal>
      )}
    </div>
  );
}
